import AboutGuide from "../../Components/AboutGuide";
import styles from "../../Styles/Homepage.module.scss";
import { useParams } from "react-router-dom";

function Homepage() {
  const params = useParams();

  let dates = "";

  switch (params.trip) {
    case "October-2026":
      dates = "September 29 - October 13, 2026";
      break;
    case "trip":
      dates = "";
      break;
  }
  return (
    <div className={styles.backgroundPicturePatmos}>
      <div className={styles.titleBox}>
        <h1>Go to the island of the apocalypse:</h1>
        <p className={styles.title}>Patmos</p>
        <p className={styles.dates}>{dates}</p>
        <div className={styles.description}>
          <p>
            Visit the Island of Patmos, where the Apostle John received and
            wrote down the book of Revelation. On this rugged and remote island,
            study the message of the Apocalypse with a small group in a
            beautiful and charming context.{" "}
          </p>
        </div>
        <div>
          <AboutGuide />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
